export default __webpack_public_path__ + "static/PPEditorialNew-LightItalic-dc2879068140388156f9dcbf9a794e36.eot";